module.exports = __webpack_public_path__ + "static/fonts/Robotobolditalic.8ec9e46.ttf";